import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { getStyles } from './styles';
import { Autocomplete, Box, Button, CircularProgress, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import LoadBar from '../../../../utils/LoadBar';
import { getComponentsStyles } from "../../../../styles/componentsStyles";
import { useAppContext } from '../../../../context/AppContext';
import { Refresh } from '@mui/icons-material';

function ChatbotAuthentication({ dataLoading, action_type, allTokens, datasets, getAllTokensDetails, tokenLoading, onSave, onCancel, onNext }) {

    const theme = useTheme();
    const styles = getStyles(theme);
    const componentsStyles = getComponentsStyles(theme);
    const { setAppDetails, appDetails } = useAppContext();
    const [formErrors, setFormErrors] = useState({});
    const [availDatasets, setAvailDatasets] = useState([])

    useEffect(() => {
        const appDatasets = appDetails?.dataset ?? [];
        const selected_datasets = datasets?.filter(item => appDatasets?.some(ds => ds?.payload?.__auto_id__ === item?.payload?.__auto_id__)) || [];
        const current_default = appDetails?.default_dataset ?? null;
        const is_default_available = selected_datasets?.find(item => item?.payload?.__auto_id__ === current_default?.payload?.__auto_id__) ?? null;
        if (!is_default_available) {
            setAppDetails((prev) => ({ ...prev, default_dataset: null }))
        }
        setAvailDatasets(selected_datasets);
    }, [datasets, appDetails]);

    useEffect(() => {
        const errors = { ...formErrors }
        if (formErrors?.service_agent_token && appDetails?.authConfigData?.service_agent_token) { delete errors?.service_agent_token }
        if (JSON.stringify(errors) !== JSON.stringify(formErrors)) { setFormErrors(errors) }
    }, [appDetails, formErrors]);

    const handleNext = () => {
        const errors = {};
        if (appDetails?.authConfigData?.auth_type === "auth") {
            if (!appDetails?.authConfigData?.service_agent_token) { errors.service_agent_token = 'This filed is required' }
        }
        if (Object.keys(errors).length === 0) {
            onNext('test-launch')
        }
        else {
            setFormErrors(errors);
        }
    }

    return (
        <Box sx={styles.mainContainer}>
            <Box sx={styles.cardContainer}>

                {(dataLoading) && <LoadBar />}

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '600' }}>Authentication</Typography>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Button
                            sx={{ backgroundColor: '#0B51C5', borderRadius: '20px', width: '100px' }}
                            onClick={() => { action_type === "update" ? onSave('authentication') : handleNext() }}
                            disabled={dataLoading || tokenLoading}
                        >
                            <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#FFFFFF' }}>
                                {action_type === "update" ? 'SAVE' : 'NEXT'}
                            </Typography>
                        </Button>
                        <Button
                            onClick={onCancel}
                            sx={{ backgroundColor: '#DEDEDE', borderRadius: '20px', width: '100px' }}
                        >
                            <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#404040' }}>
                                CANCEL
                            </Typography>
                        </Button>
                    </Box>
                </Box>

                <Box sx={{ border: '1px solid #D9D9D9', borderRadius: '5px', padding: '20px', marginTop: '20px', width: '600px' }}>

                    {appDetails?.app_bot_type === 'advanced_bot' &&
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
                            <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>Authentication Required?</Typography>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                value={appDetails?.authConfigData?.auth_type}
                                onChange={(e) => setAppDetails((prev) => ({ ...prev, authConfigData: { ...prev.authConfigData, auth_type: e.target.value } }))}
                                style={{ display: 'flex', flexDirection: 'row' }}
                            >
                                <FormControlLabel value="auth" control={<Radio color='#59A292' />} label="Yes" />
                                <FormControlLabel value="no_auth" control={<Radio color='#59A292' />} label="No" />
                            </RadioGroup>
                        </Box>}

                    <Box mt={appDetails?.app_bot_type === 'advanced_bot' ? 1 : 0} >
                        <FormControl >
                            <Typography sx={{ ...styles.paraText, marginBottom: '6px' }}>Select API Key</Typography>

                            <Box display={'flex'} alignItems={'center'}>
                                <Autocomplete
                                    id="expiration"
                                    size="small"
                                    disabled={dataLoading}
                                    options={
                                        Array.isArray(allTokens)
                                            ? allTokens
                                                .filter(item => item?.payload?.name && item?.payload?.token && item?.payload?.__auto_id__)
                                                .map(item => ({
                                                    token: item.payload.token,
                                                    __auto_id__: item.payload.__auto_id__,
                                                    name: item.payload.name,
                                                }))
                                            : []
                                    }
                                    getOptionLabel={(option) => option.name || ""}
                                    value={appDetails?.authConfigData?.service_agent_token || null}
                                    onChange={(e, newValue) => {
                                        setAppDetails(prev => ({
                                            ...prev,
                                            authConfigData: {
                                                ...prev.authConfigData,
                                                service_agent_token: newValue || "",
                                            },
                                        }));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Search or select a token"
                                            sx={{ ...componentsStyles.selectField, width: "300px" }}
                                        />
                                    )}
                                    noOptionsText="No Token Available"
                                />
                                {tokenLoading ?
                                    (<CircularProgress size={'22px'} sx={{ marginLeft: '10px' }} />)
                                    :
                                    (<IconButton
                                        sx={{ marginLeft: '10px' }}
                                        onClick={getAllTokensDetails}
                                    >
                                        <Refresh />
                                    </IconButton>)
                                }
                            </Box>
                            {formErrors.service_agent_token && <Typography sx={{ ...styles.paraText, color: 'red' }}>{formErrors.service_agent_token}</Typography>}
                        </FormControl>
                    </Box>
                </Box>


                <Typography sx={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>Defaults</Typography>
                <Box sx={{ border: '1px solid #D9D9D9', borderRadius: '5px', padding: '20px', marginTop: '10px', width: '600px' }}>
                    <Box mt={1}>
                        <Typography mb={1}>Default Dataset</Typography>
                        <Autocomplete
                            size='small'
                            disabled={dataLoading || (appDetails?.app_bot_type === "simple_bot")}
                            options={availDatasets || []}
                            sx={{ width: '200px' }}
                            value={appDetails.default_dataset}
                            getOptionLabel={(option) => option?.payload?.dataset_name || ''}
                            renderInput={(params) => (<TextField {...params} placeholder="Select Dataset" />)}
                            onChange={(e, newValue) => setAppDetails((prev) => ({ ...prev, default_dataset: newValue }))}
                            renderOption={(props, option) => (
                                <li {...props} style={{ paddingLeft: `${10 + (option?.depth || 0) * 22}px` }}>
                                    <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>{option?.payload?.dataset_name}</Typography>
                                </li>
                            )}
                        />
                    </Box>

                    <Box marginTop={'20px'}>
                        <FormControl>
                            <Typography sx={{ ...styles.paraText, marginBottom: '6px' }}>Welcome Message</Typography>
                            <TextField
                                id="welcome-message"
                                placeholder='Welcome Message'
                                size='small'
                                sx={{ ...componentsStyles.textField, width: '500px' }}
                                value={appDetails.welcome_message}
                                onChange={(e) => setAppDetails((prev) => ({ ...prev, welcome_message: e.target.value }))}
                            />
                        </FormControl>
                    </Box>
                </Box>

                <Typography sx={{ fontSize: '16px', fontWeight: '600', marginTop: '30px' }}>LLM Type</Typography>
                <Box sx={{ border: '1px solid #D9D9D9', borderRadius: '5px', padding: '20px', marginTop: '10px', width: '600px' }}>
                    <Box mt={1}>
                        <Typography sx={{ ...styles.paraText, marginBottom: '6px' }}>Select LLM Type</Typography>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            value={appDetails?.authConfigData?.llm_type}
                            onChange={(e) => setAppDetails((prev) => ({ ...prev, authConfigData: { ...prev.authConfigData, llm_type: e.target.value } }))}
                            style={{ display: 'flex', flexDirection: 'row' }}
                        >
                            <FormControlLabel value={"gemini"} control={<Radio color='#59A292' />} label="Gemini" />
                            <FormControlLabel value={"local"} control={<Radio color='#59A292' />} label="Local" />
                        </RadioGroup>
                    </Box>
                </Box>
            </Box>
        </Box >
    )
}

export default ChatbotAuthentication;